import React, { useEffect, useRef, useMemo } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import allReportsHindidata from "../../../json-data/allReportsHindi.json";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import allreportsdata from "../../../json-data/allreports.json";
import { fetchArchiveServicesProfileSchoolData } from "../../../redux/thunks/archiveServicesThunk";
import { fetchSchoolProfileDataYear } from "../../../redux/thunks/dashboardThunk";
import { useExportToExcel } from "../../../pdfAndExcellUtils/pdfAndExcellUtils";
import {
  categoryMappings as originalCategoryMappings,
  initialFilterSchoolData,
  selectedDYear,
  nationalWiseName,
  stateWiseName,
  district,
  districtWiseName,
  blockWiseName,
  block,
  generateTextContent,
  excelStyles
} from "../../../constants/constants";
import { allFilter } from "../../../redux/slice/schoolFilterSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchSchoolProfileStatsData } from "../../../redux/thunks/dashboardThunk";
import { handleMissingData } from "../../../utils/handleMissingData";

import "../infra.css";
import "../report.scss";
import {
  state_gov_mgt_code,
  gov_aided_mgt_code,
  pvt_uaided_mgt_code,
  ctrl_gov_mgt_code,
  other_mgt_code,
  pr_sch_code,
  upr_pr_code,
  hr_sec_code,
  sec_sch_code,
  pre_pr_sch_code,
  foundational_preparatory,
  middle,
  secondary
} from "../../../constants/constants";
import {
  SchoolGraph1006,
  SchoolGraphCat1006,
  SchoolGraph2Manage1006,
  SchoolGraph2Cat1006,
} from "./SchoolGraph";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HC_more from "highcharts/highcharts-more";
import { useLocation } from "react-router-dom";
import { GlobalLoading } from "../../GlobalLoading/GlobalLoading";
import { removeAllDistrict } from "../../../redux/thunks/districtThunk";
import { removeAllBlock } from "../../../redux/thunks/blockThunk";
import { handleActiveTabs } from "../../../redux/slice/headerSlice";
import { useTranslation } from "react-i18next";
import FilterDropdownCommom358 from "../../Home/filter/FilterDropdownCommon358";
import { ScrollToTopOnMount } from "../../Scroll/ScrollToTopOnMount";
import satyamevaimg from "../../../assets/images/satyameva-jayate-img.png";
import udise from "../../../assets/images/udiseplu.jpg";
import nic from "../../../assets/images/nic-sm-logo.png";
import useReportOverallLocationSum from "../../../CustomHook/useReportOverallLocationSum"
import Footer from "../../Header/Footer";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/accessibility")(Highcharts);
require("highcharts/modules/export-data.js")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/treemap")(Highcharts);
require("highcharts/modules/treegraph")(Highcharts);
HC_more(Highcharts);
export default function InfrastructureReport1010() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const queryString = window.location.hash.substring(1);
  const urlParams = new URLSearchParams(queryString.split("?")[1]);
  const paramValue = urlParams.get("type");
  //const school_data = useSelector((state) => state.school?.data?.data);
  const school_datas = useSelector((state) => state.schoolProfile);

  const [categoryMappings, setCategoryMappings] = useState({});
  const [school_data, setSchoolData] = useState([]);
  const [isScrollComplete, setIsScrollComplete] = useState(false);
  const [isCheckFilter, setIsCheckFilter] = useState(false);
  const [isNEP, setIsNEP] = useState(true); // true => NEP, false => Pre NEP
  // Create the translated category mappings
  useEffect(() => {
    // alert('1003')
    const translatedMappings = {};
    for (const [key, value] of Object.entries(originalCategoryMappings)) {
      translatedMappings[key] = t(`categories.${key}`);
    }
    setCategoryMappings(translatedMappings);
  }, [t]);

  //console.log('school_datas', school_datas);
  const initialPayload = {...initialFilterSchoolData, itemGroupId: 1, itemId: 5};
  //console.log('initialPayload', initialPayload)
 
  useEffect(() => {
    if (school_datas?.data?.data) {
      //console.log("datas--->",school_datas?.data?.data);
      // const updatedSchoolData = school_datas.data.data.map((school) => {
      //   if (categoryMappings.hasOwnProperty(school.schCategoryDesc)) {
      //     return {
      //       ...school,
      //       schCategoryDesc: categoryMappings[school.schCategoryDesc],
      //     };
      //   }
      //   return school;
      // });

      let count = 0

      const updatedSchoolData = school_datas?.data?.data?.map((school) => {
        if(isNEP){
          let updatedSchool = { ...school, foundationalAndPreparatory:0, middle:0, secondary: 0 }; // Create a copy of the school object
        

        if (categoryMappings.hasOwnProperty(school.schCategoryDesc)) {
          updatedSchool.schCategoryDesc = categoryMappings[school.schCategoryDesc];
        }

            updatedSchool.foundationalAndPreparatory= parseInt(updatedSchool.totSchCat1) + parseInt(updatedSchool?.totSchCat12)
            // updatedSchool.foundationalAndPreparatory= parseInt(updatedSchool.totSchCat1);
            updatedSchool.middle= parseInt(updatedSchool.totSchCat2) + parseInt(updatedSchool?.totSchCat4)
            updatedSchool.secondary= parseInt(updatedSchool.totSchCat3) + parseInt(updatedSchool?.totSchCat5) + 
                                        parseInt(updatedSchool?.totSchCat6) + parseInt(updatedSchool?.totSchCat7) + parseInt(updatedSchool?.totSchCat8) + 
                                        parseInt(updatedSchool?.totSchCat10) + parseInt(updatedSchool?.totSchCat11)

        
        //console.log('updatedSchool', updatedSchool);
       
        if(updatedSchool.schManagementCode === '1' || updatedSchool.schManagementCode === '2' || updatedSchool.schManagementCode === '3' || updatedSchool.schManagementCode === '6'
            || updatedSchool.schManagementCode === '89' || updatedSchool.schManagementCode === '90' || updatedSchool.schManagementCode === '91'){
               //console.log("totSchCat1--",updatedSchool.totSchCat1)
                count += parseInt(updatedSchool.totSchCat1);
            }
    

        if (updatedSchool.schCategoryCode === "1" || updatedSchool.schCategoryCode === "12") {
          updatedSchool.schCategoryDesc = "Foundational and Preparatory";
        }
         else if (updatedSchool.schCategoryCode === "2") {
          updatedSchool.schCategoryDesc = "Middle (1-8)";
        } 
        else if (updatedSchool.schCategoryCode === "3") {
          updatedSchool.schCategoryDesc = "Secondary (1-12)";
        }
        else if (updatedSchool.schCategoryCode === "4") {
          updatedSchool.schCategoryDesc = "Middle (6-8)";
        }
        else if (updatedSchool.schCategoryCode === "5") {
          updatedSchool.schCategoryDesc = "Secondary (6-12)";
        }
        else if (updatedSchool.schCategoryCode === "6") {
          updatedSchool.schCategoryDesc = "Secondary (1-10)";
        }
        else if (updatedSchool.schCategoryCode === "7") {
          updatedSchool.schCategoryDesc = "Secondary (6-10)";
        }
        else if (updatedSchool.schCategoryCode === "8") {
          updatedSchool.schCategoryDesc = "Secondary (9-10)";
        }
        else if (updatedSchool.schCategoryCode === "9") {
          updatedSchool.schCategoryDesc = "Secondary (1-12)";
        }
        else if (updatedSchool.schCategoryCode === "10") {
          updatedSchool.schCategoryDesc = "Secondary (9-12)";
        }
        else if (updatedSchool.schCategoryCode === "11") {
          updatedSchool.schCategoryDesc = "Secondary (11-12)";
        }
      
        return updatedSchool;
        }
        else {
          if (categoryMappings.hasOwnProperty(school.schCategoryDesc)) {
            return {
              ...school,
              schCategoryDesc: categoryMappings[school.schCategoryDesc],
            };
          }
          return school;
        }
        
      });

      //console.log('countttt', count)

      setSchoolData(updatedSchoolData);
    }
  }, [school_datas, categoryMappings, isNEP]);

  const [local_state, setLocalStateName] = useState("All India/National");
  const [local_district, setLocalDistrictName] = useState("District");
  const [local_block, setLocalBlockName] = useState("Block");
  const schoolFilter = useSelector((state) => state.schoolFilter);
  ////console.log('schoolFilter', schoolFilter)
  const filterObj = structuredClone(schoolFilter);
  const [showTransposed, setShowTransposeds] = useState(false);
  const [customColumnNames, setCustomColumns] = useState("");
  const local_year = window.localStorage.getItem("year");
  const stateName = localStorage.getItem("state");
  const headerData = useSelector((state) => state.header);
  const [groupKeys, setGroupKeys] = useState({
    schManagementBroad: true,
    schManagementDesc: false,
    schCategoryBroad: true,
    schCategoryDesc: false,
    schLocationDesc: false,
  });
  useEffect(() => {
    dispatch(removeAllDistrict());
    dispatch(removeAllBlock());
  }, []);
  useEffect(() => {
    window.localStorage.setItem("state", "All India/National");
    window.localStorage.setItem("map_state_name", "All India/National");
    window.localStorage.setItem("map_district_name", "District");
    window.localStorage.setItem("district", "District");
    window.localStorage.setItem("block", "Block");
  }, []);

  useEffect(() => {
    ////console.log('filterObj', filterObj)
    setLocalStateName(localStorage.getItem("state"));
    setLocalStateName(localStorage.getItem("map_state_name"));

    setLocalDistrictName(localStorage.getItem("map_district_name"));
    setLocalBlockName(localStorage.getItem("block"));
  }, [filterObj, headerData.activeTab]);

  const [mgt, setMgt] = useState("active");
  const [mgt_Details, setMgtDetail] = useState("");
  const [cat, setCat] = useState("active");
  const [cat_Details, setCatDetail] = useState("");
  const [ur, setUR] = useState("");
  const [multiMgt, setMultiMgts] = useState("multibtn");
  const [multiCat, setMultiCats] = useState("multibtn");
  const [queryParameters] = useSearchParams();
  const id = queryParameters.get("id");
  const type = queryParameters.get("type");
  const [graphData, setGraphData] = useState([]);
  const [intialTeacherData, setIntialTeacherData] = useState([]);
  const gridApiRef = useRef(null);
  useEffect(() => {
    if (school_data) {
      setIntialTeacherData(school_data);
    }
  }, [school_data]);
  // Taking the both reports data condition wise for language change

  useEffect(() => {
    const reportsData =
      i18n.language === "hi" ? allReportsHindidata : allreportsdata;

    for (const category in reportsData) {
      const foundReport = reportsData[category].find(
        (report) => report.id === parseInt(id)
      );
      if (foundReport) {
        setReport(foundReport);
        break;
      }
    }
  }, [id, i18n.language]);

  const [report, setReport] = useState(null);
  const [gridApi, setGridApi] = useState();
  const [arrGroupedData, setArrGroupedData] = useState([]);
  const [cloneFilterDatas, setCloneFilterDatas] = useState([]);
  const [pinnedBottomRowDataByRows, setPinnedBottomRowDataByRow] = useState([]);
  const [activeTab, setActiveTab] = useState(type);
  const [gridRefreshKey, setGridRefreshKey] = useState(0);
  const school_data_valueTypes =
    useSelector((state) => state?.schoolStats) || {};
  const school_data_Years =
    useSelector((state) => state?.schoolStatsYear) || [];
  const school_data_valueType =
    useSelector((state) => state?.schoolStats?.data?.data?.[0]) || {};
  const school_data_Year =
    useSelector((state) => state?.schoolStatsYear?.data?.data) || [];

  const [data, setData] = useState([]);
  dispatch(handleActiveTabs(activeTab));

  ////console.log('local_state', local_state)
  const filter_query_by_location =
    (local_state === "All India/National" &&
      groupKeys.schCategoryBroad &&
      groupKeys.schCategoryDesc &&
      groupKeys.schManagementDesc &&
      groupKeys.schCategoryBroad) ||
    local_state === "State Wise" ||
    local_district === "District Wise" ||
    local_block === "Block Wise";

    ////console.log('filter_query_by_location', filter_query_by_location)
  const [columns, setColumn] = useState([
    {
      headerName: "Serial Number",
      field: "Serial Number",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
    },
    {
      headerName: "Location",
      field: "regionName",
      hide: false,
    },
    {
      headerName: "School Management(Broad)",
      field: "schManagementBroad",
      suppressColumnsToolPanel: true,
      hide: true,
      cellRenderer: (params) => (params.value ? params.value : "-"),
    },
    {
      headerName: "School Management(Detailed)",
      field: "schManagementDesc",
      suppressColumnsToolPanel: true,
      hide: true,
      cellRenderer: (params) => (params.value ? params.value : "-"),
    },
    {
      headerName: "School Category(Broad)",
      field: "schCategoryBroad",
      suppressColumnsToolPanel: true,
      hide: true,
      cellRenderer: (params) => (params.value ? params.value : "-"),
    },
    {
      headerName: "School Category(Detailed)",
      field: "schCategoryDesc",
      suppressColumnsToolPanel: true,
      hide: true,
    },

    {
      headerName: "Total No. of Schools",
      field: "totSch",
      cellClass: 'ag-right-aligned-cell'
      
    },
    // {
    //     headerName: "Foundational and Preparatory",
    //     field: "foundationalAndPreparatory",
    //     cellClass: 'ag-right-aligned-cell',
    //     suppressColumnsToolPanel: true,
    //     hide: false,
    //   },
    //   {
    //     headerName: "Middle",
    //     field: "middle",
    //     cellClass: 'ag-right-aligned-cell',
    //     suppressColumnsToolPanel: true,
    //     hide: false,
    //   },
    //   {
    //     headerName: "Secondary",
    //     field: "secondary",
    //     cellClass: 'ag-right-aligned-cell',
    //     suppressColumnsToolPanel: true,
    //     hide: false,
    //   },
  ]);

//   alert("post set column--->"+JSON.stringify(columns));
  // useEffect(() => {
  //   if (paramValue === "table") {
  //     dispatch(allFilter(initialFilterSchoolData));
  //     dispatch(fetchArchiveServicesProfileSchoolData(initialFilterSchoolData));
  //   } else if (paramValue === "graph") {
  //     initialFilterSchoolData.valueType = 2;
  //     dispatch(allFilter(initialFilterSchoolData));
  //     dispatch(fetchSchoolProfileStatsData(initialFilterSchoolData));
  //     initialFilterSchoolData.valueType = 1;
  //     dispatch(allFilter(initialFilterSchoolData));
  //     dispatch(fetchSchoolProfileDataYear(initialFilterSchoolData));
  //   }
  // }, [paramValue, i18n.language]);

  const [defColumnDefs] = useState({
    flex: 1,
    minWidth: 150,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    // filter: true,
    autoHeaderHeight: true,
    headerClass: "headerStyle"
  });

  const countTotalPinnedWithRightVisible = (visibleArr,obj) => {
    let total = 0;
    
    for (const key in obj) {
     for(const key2 in visibleArr){
      if(visibleArr[key2]?.colId == key){
      const value = obj[key];
      if(key !="Serial Number" && key !="Overall"){
      if (Number.isInteger(value)) {
        total += value;
      }
    }
  }
    }
  }
    return total;
  };

  function calculateTotalOverall(data,fieldName) {
    
    if (!data) return 0;
    return data.reduce(
      (total, row) => total + parseFloat(row[fieldName] || 0),
      0
    );
  }
  


  function onColumnVisible(event) {
   
    setTimeout(() => {
      const columnId = event?.column?.colId;
      const visible = event.visible;
       const gridApi1 = gridApiRef.current;
      
      const allData = [];
  
      const visibleColumns = gridApi.api.getAllDisplayedColumns();
      
  
  
      gridApi1.forEachNodeAfterFilter((node) => {
        if(node.data['School Management(Broad)'] !="Overall"){
      allData.push(node.data);
        }
    });
  
    const newArr = allData.map((item, idx) => {
  
      return {
        ...item,
        Overall: countTotalPinnedWithRightVisible(visibleColumns,item),
        "Serial Number": idx + 1,
      };
    });
    setArrGroupedData(newArr);
  
    const appendedObj = {};
    visibleColumns.forEach((item) => {
        appendedObj[item.colId] = calculateTotalOverall(newArr,item.colId);  
    });
  
    appendedObj["School Category(Broad)"] = "";
    appendedObj["School Category(Detailed)"] = "";
    appendedObj["schLocationDesc"] = "";
    appendedObj["School Management(Broad)"] = "";
    appendedObj["School Management(Detailed)"] = "";
    appendedObj["Professional Qualification"] = "";
    appendedObj["Location"] = "";
    appendedObj["schTypeDesc"] = "";
    if (groupKeys.schManagementBroad) {
      appendedObj["School Management(Broad)"] = "Total";
    } else if (groupKeys.schManagementDesc) {
      appendedObj["School Management(Detailed)"] = "Total";
    } else if (groupKeys.schCategoryBroad) {
      appendedObj["School Category(Broad)"] = "Total";
    } else if (groupKeys.schCategoryDesc) {
      appendedObj["School Category(Detailed)"] = "Total";
    } else if (groupKeys.schTypeDesc) {
      appendedObj["schTypeDesc"] = "Total";
    } else if (groupKeys.schLocationDesc) {
      appendedObj["Location"] = "Total";
    }
    
  
    setPinnedBottomRowDataByRow([appendedObj]);
    
  
      if (columnId === "schManagementBroad") {
        setGroupKeys((prev) => ({
          ...prev,
          schManagementBroad: visible,
        }));
        setMgt(() => (visible ? "active" : ""));
        setMultiMgts("multibtn");
      }
      if (columnId === "schManagementDesc") {
        setGroupKeys((prev) => ({
          ...prev,
          schManagementDesc: visible,
        }));
        setMgtDetail(() => (visible ? "active" : ""));
        setMultiMgts("multibtn");
      }
      if (columnId === "schCategoryBroad") {
        setGroupKeys((prev) => ({
          ...prev,
          schCategoryBroad: visible,
        }));
        setCat(() => (visible ? "active" : ""));
  
        setMultiCats("multibtn");
      }
      if (columnId === "schCategoryDesc") {
        setGroupKeys((prev) => ({
          ...prev,
          schCategoryDesc: visible,
        }));
        setCatDetail(() => (visible ? "active" : ""));
  
        setMultiCats("multibtn");
      }
  
      if (columnId === "schLocationDesc") {
        setGroupKeys((prev) => ({
          ...prev,
          schLocationDesc: visible,
        }));
        setUR(() => (visible ? "active" : ""));
      }
    }, 100)
  
  }
  const onGridReady = (params) => {
    gridApiRef.current = params.api;
    setColumnVisibility(groupKeys);
    setGridApi(params);
  };

  const setColumnVisibility = (keys) => {
    if (gridApiRef.current) {
      const gridApi = gridApiRef.current;
      Object.keys(keys).forEach((key) => {
        gridApi?.columnApi?.setColumnVisible(key, keys[key]);
      });
    }
  };
  const handleCustomKeyInAPIResponse = () => {
    const arr = [];
    school_data?.forEach((item, idx) => {
      let appendedObj = { ...item };
      /* broad management key added*/
      if (state_gov_mgt_code.includes(item.schManagementCode)) {
        appendedObj.schManagementBroad = t("state_government");
      } else if (gov_aided_mgt_code.includes(item.schManagementCode)) {
        appendedObj.schManagementBroad = t("govt_aided");
      } else if (pvt_uaided_mgt_code.includes(item.schManagementCode)) {
        appendedObj.schManagementBroad = t("privateUnaided");
      } else if (ctrl_gov_mgt_code.includes(item.schManagementCode)) {
        appendedObj.schManagementBroad = t("centralGovernment");
      } else if (other_mgt_code.includes(item.schManagementCode)) {
        appendedObj.schManagementBroad = t("others");
      }
        // /* broad category key added*/
        // if (foundational_preparatory.includes(item.schCategoryCode)) {
        //   appendedObj.schCategoryBroad = "Foundational and Preparatory";
        // } else if (middle.includes(item.schCategoryCode)) {
        //   appendedObj.schCategoryBroad = "Middle";
        // } 
        // // else if (secondary.includes(item.schCategoryCode)) {
        // //   appendedObj.schCategoryBroad = "Higher Secondary (HSEC)";
        // // } 
        // else if (secondary.includes(item.schCategoryCode)) {
        //   appendedObj.schCategoryBroad = "Secondary";
        // } 
      arr.push(appendedObj);
    });
    setData(arr);
  };

  const generateKey = (item, filters) => {
    const {
      regionName,
      schManagementBroad,
      schManagementDesc,
      schCategoryBroad,
      schCategoryDesc,
    } = item;
    let keyParts = [regionName];

    if (filters.schManagementBroad) keyParts.push(schManagementBroad);
    if (filters.schManagementDesc) keyParts.push(schManagementDesc);
    if (filters.schCategoryBroad) keyParts.push(schCategoryBroad);
    if (filters.schCategoryDesc) keyParts.push(schCategoryDesc);

    return keyParts.join("-");
  };

   const groupData = (data, filters) => {
     const groupedData = {};
 
     data.forEach((item) => {
       const key = generateKey(item, filters);
       console.log("key-----", key);
       if (!groupedData[key]) {
         groupedData[key] = {
           ...item,
           totSch: 0,
           foundationalAndPreparatory: 0,
           middle: 0,
           secondary: 0,
           totSchCat1: 0,
           totSchCat2: 0,
           totSchCat3: 0,
           totSchCat4: 0,
           totSchCat5: 0,
           totSchCat6: 0,
           totSchCat7: 0,
           totSchCat8: 0,
           totSchCat10: 0,
           totSchCat11: 0,
           totSchCat12: 0,
         };
       }
       groupedData[key].totSch += parseInt(item.totSch, 10);
       groupedData[key].foundationalAndPreparatory += parseInt(
         item.foundationalAndPreparatory,
         10
       );
       groupedData[key].middle += parseInt(item.middle, 10);
       groupedData[key].secondary += parseInt(item.secondary, 10);
       groupedData[key].totSchCat1 += parseInt(item.totSchCat1, 10);
       groupedData[key].totSchCat2 += parseInt(item.totSchCat2, 10);
       groupedData[key].totSchCat3 += parseInt(item.totSchCat3, 10);
       groupedData[key].totSchCat4 += parseInt(item.totSchCat4, 10);
       groupedData[key].totSchCat5 += parseInt(item.totSchCat5, 10);
       groupedData[key].totSchCat6 += parseInt(item.totSchCat6, 10);
       groupedData[key].totSchCat7 += parseInt(item.totSchCat7, 10);
       groupedData[key].totSchCat8 += parseInt(item.totSchCat8, 10);
       groupedData[key].totSchCat10 += parseInt(item.totSchCat10, 10);
       groupedData[key].totSchCat11 += parseInt(item.totSchCat11, 10);
       groupedData[key].totSchCat12 += parseInt(item.totSchCat12, 10);
     });
 
     console.log('groupedData', groupedData)
     return Object.values(groupedData);
   };
  const handleButtonClick = (type, detailType, e) => {
    setGridRefreshKey((prevKey) => prevKey + 1);
    handleFilterClick(type, detailType);
    if (type === "School Management" && detailType === "desc") {
      setMgtDetail("active");
      setMgt("");
    } else if (type === "School Management" && detailType === "broad") {
      setMgt("active");
      setMgtDetail("");
    }
    if (type === "School Category" && detailType === "desc") {
      setCatDetail("active");
      setCat("");
    } else if (type === "School Category" && detailType === "broad") {
      setCat("active");
      setCatDetail("");
    }
    setTimeout(() => {
      switchColumnsToRow(e, true);
    }, 0);
  };
  const calculatePinnedBottomRowData = () => {
    const totalRow = {};

    columns.forEach((column) => {
      if (
        column.field !== "Serial Number" &&
        column.field !== "Location" &&
        column.field !== "Total"
      ) {
        totalRow[column.field] = calculateTotal(column.field);
      }
    });

    totalRow["totSch"] = calculateTotal("totSch");

    if (getLastTrueToShowTotal()) {
      totalRow[getLastTrueToShowTotal()] = "Total";
    } else {
      totalRow["regionName"] = "Total";
    }

    return [totalRow];
  };

  useEffect(() => {
    ////console.log('local_state', local_state)
    if (isNEP) {
      setColumn((prevColumns) => {
      const updatedColumns = [...prevColumns];
      const firstChild = updatedColumns;
// alert("first child-->"+JSON.stringify(firstChild));
      const updateColumnVisibility = (field, isVisible) => {
        ////console.log('field', field, 'isVisible', isVisible)
        const index = firstChild.findIndex((col) => col.field === field);
        if (index !== -1) {
          firstChild[index].hide = !isVisible;
        }
      };

      if (groupKeys.schManagementBroad !== undefined) {
        updateColumnVisibility(
          "schManagementBroad",
          groupKeys.schManagementBroad
        );
        updateColumnVisibility("foundationalAndPreparatory", false);
        updateColumnVisibility("middle", groupKeys.middle);
        updateColumnVisibility("secondary", groupKeys.secondary);
      }
      if (groupKeys.schManagementDesc !== undefined) {
        updateColumnVisibility(
          "schManagementDesc",
          groupKeys.schManagementDesc
        );
        updateColumnVisibility("foundationalAndPreparatory", false);
        updateColumnVisibility("middle", groupKeys.middle);
        updateColumnVisibility("secondary", groupKeys.secondary);
      }
      if (groupKeys.schCategoryBroad !== undefined) {
        updateColumnVisibility("schCategoryBroad", groupKeys.schCategoryBroad);
     
      }
      if (groupKeys.schCategoryDesc !== undefined) {
        updateColumnVisibility("schCategoryDesc", groupKeys.schCategoryDesc);
      }
      if (groupKeys.schLocationDesc !== undefined) {
        updateColumnVisibility("schLocationDesc", groupKeys.schLocationDesc);
      }


      const updatedDefs = updatedColumns.map((colGroup) => ({
        ...colGroup,
        children: colGroup.children?.map((col) => ({
          ...col,
          hide: firstChild.find((c) => c.field === col.field)?.hide || col.hide,
        })),
      }));

      return updatedDefs;
    });

    const grouped = groupData(data, groupKeys);
    //console.log("grouped--->",JSON.stringify(grouped))
    for(let i = 0; i < grouped.length; i++){
      if(groupKeys.schCategoryBroad){
        grouped[i].totSch = grouped[i]['foundationalAndPreparatory'] + grouped[i]['middle'] + grouped[i]['secondary']
      }else if(groupKeys.schCategoryDesc){
        grouped[i].totSch = parseInt(grouped[i]['foundationalAndPreparatory']) + parseInt(grouped[i]['totSchCat2'] ) +  parseInt(grouped[i]['totSchCat3'])+ parseInt(grouped[i]['totSchCat4']) + parseInt(grouped[i]['totSchCat5']) + parseInt(grouped[i]['totSchCat6'])
                            + parseInt(grouped[i]['totSchCat7']) + parseInt(grouped[i]['totSchCat8']) + parseInt(grouped[i]['totSchCat10']) + parseInt(grouped[i]['totSchCat11'])

                          }

  
    }

        setArrGroupedData(grouped);
    setCloneFilterDatas(grouped);
    setColumnVisibility(groupKeys);

    }
    else if (!isNEP) {
      setColumn((prevColumns) => {
        const updatedColumns = [...prevColumns];
        const firstChild = updatedColumns;

        const updateColumnVisibility = (field, isVisible) => {
          const index = firstChild.findIndex((col) => col.field === field);
          if (index !== -1) {
            firstChild[index].hide = !isVisible;
          }
        };

        if (groupKeys.schManagementBroad !== undefined) {
          updateColumnVisibility(
            "schManagementBroad",
            groupKeys.schManagementBroad
          );
        }
        if (groupKeys.schManagementDesc !== undefined) {
          updateColumnVisibility(
            "schManagementDesc",
            groupKeys.schManagementDesc
          );
        }
        if (groupKeys.schCategoryBroad !== undefined) {
          updateColumnVisibility(
            "schCategoryBroad",
            groupKeys.schCategoryBroad
          );
        }

        if (groupKeys.schCategoryDesc !== undefined) {
          updateColumnVisibility("schCategoryDesc", groupKeys.schCategoryDesc);
        }
        if (groupKeys.schLocationDesc !== undefined) {
          updateColumnVisibility("schLocationDesc", groupKeys.schLocationDesc);
        }
        const updatedDefs = updatedColumns.map((colGroup) => ({
          ...colGroup,
          children: colGroup.children?.map((col) => ({
            ...col,
            hide:
              firstChild.find((c) => c.field === col.field)?.hide || col.hide,
          })),
        }));

        return updatedDefs;
      });

      const grouped = groupData(data, groupKeys);
      setArrGroupedData(grouped);
      
      setCloneFilterDatas(grouped);
      setColumnVisibility(groupKeys);
    }


  }, [groupKeys, data]);

  const countTotalPinnedWithRight = (obj) => {
    let total = 0;
    for (const key in obj) {
      if (!key.includes("Total")) {
        const value = obj[key];
        if (Number.isInteger(value)) {
          total += value;
        }
      }
    }
    return total;
  };

  const handleFilterClick = (type, detailType) => {
    setGroupKeys((prevFilters) => {
      const newFilters = { ...prevFilters };
      if (type === "School Management") {
        newFilters.schManagementBroad = detailType === "broad";
        newFilters.schManagementDesc = detailType === "desc";
      } else if (type === "School Category") {
        newFilters.schCategoryBroad = detailType === "broad";
        newFilters.schCategoryDesc = detailType === "desc";
      } else if (type === "Urban/Rural") {
        newFilters.schLocationDesc = !prevFilters.schLocationDesc;
      }
      return newFilters;
    });
  };

  const switchColumnsToRow = (e, flag = false) => {
    setShowTransposeds(false);

    if (flag || !showTransposed) {
      const arr = [];
      const uniqueKeys = new Set();
      let customColumnName = "";
      ////console.log("cloneFilterDatas---->"+JSON.stringify(cloneFilterDatas));
      if(isNEP){
          cloneFilterDatas?.forEach((row) => {
        let location = row.regionName;
        let schManagementBroad = row.schManagementBroad;
        let schManagementDesc = row.schManagementDesc;
        let foundationalAndPreparatory = row.foundationalAndPreparatory
        let middle = row.middle
        let secondary = row.secondary
        let key;

        if (groupKeys.schManagementBroad) {
          key = row.schManagementBroad;
          customColumnName = "School Management(Broad)";
          setCustomColumns("School Management(Broad)");
          uniqueKeys.add("Foundational and Preparatory");
          uniqueKeys.add("Middle");
          uniqueKeys.add("Secondary");
        } else if (groupKeys.schManagementDesc) {
          key = row.schManagementDesc;
          customColumnName = "School Management(Detailed)";
          setCustomColumns("School Management(Detailed)");
          uniqueKeys.add("Foundational and Preparatory");
          uniqueKeys.add("Middle");
          uniqueKeys.add("Secondary");
        }

        /* row wise data for category */
        ////console.log('groupKeys', groupKeys)
        if (groupKeys.schCategoryBroad) {
          key = row.schCategoryBroad;
        } else if (groupKeys.schCategoryDesc) {
            uniqueKeys.delete('Secondary')
            uniqueKeys.delete('Middle')
            uniqueKeys.add("Foundational and Preparatory");
            uniqueKeys.add("Middle (1-8)");
            uniqueKeys.add("Secondary (1-12)");
            uniqueKeys.add("Middle (6-8)");
            uniqueKeys.add("Secondary (6-12)");
            uniqueKeys.add("Secondary (1-10)");
            uniqueKeys.add("Secondary (6-10)");
            uniqueKeys.add("Secondary (9-10)");
            uniqueKeys.add("Secondary (9-12)");
            uniqueKeys.add("Secondary (11-12)");
          key = row.schCategoryDesc;
        }
        /* end here */

        ////console.log('key', key)
        key = key?.replace(/\./g, "");
        // alert("key--"+key)
        if (!uniqueKeys.has(key) && !uniqueKeys.has("")) {
        //   uniqueKeys.add(key);
        }

        const existingDataIndex = arr.findIndex(
          (data) =>
            data["Location"] === location &&
            data["School Management(Broad)"] === schManagementBroad &&
            data["School Management(Detailed)"] === schManagementDesc
        );
        if (existingDataIndex !== -1) {
          arr[existingDataIndex][key] =
            (arr[existingDataIndex][key] || 0) + parseInt(row.totSch, 10);
        } else {
          let newData = {
            Location: location,
            "School Management(Broad)": schManagementBroad,
            "School Management(Detailed)": schManagementDesc,
            "Foundational and Preparatory": foundationalAndPreparatory,
            "Middle": middle,
            "Secondary": secondary,
            "Middle (1-8)": parseInt(row.totSchCat2),
            "Secondary (1-12)": parseInt(row.totSchCat3),
            "Middle (6-8)": parseInt(row.totSchCat4),
            "Secondary (6-12)": parseInt(row.totSchCat5),
            "Secondary (1-10)": parseInt(row.totSchCat6),
            "Secondary (6-10)": parseInt(row.totSchCat7),
            "Secondary (9-10)":  parseInt(row.totSchCat8),
            "Secondary (9-12)":  parseInt(row.totSchCat10),
            "Secondary (11-12)":  parseInt(row.totSchCat11),
            Overall: parseInt(row.totSch, 10),
          };
          newData[key] = parseInt(row.totSch, 10);
          arr.push(newData);
        }
      });

      const columnHeaders = [
        "Serial Number",
        "Location",
        "School Management(Broad)",
        "School Management(Detailed)",
        ...Array.from(uniqueKeys).sort((a, b) => {
          const desiredOrder = ["Foundational and Preparatory", "Middle", "Secondary", 
                                "Middle (1-8)", "Middle (6-8)","Secondary (1-10)","Secondary (6-10)","Secondary (9-10)", 
                                "Secondary (1-12)", "Secondary (6-12)",
                                 "Secondary (9-12)", "Secondary (11-12)"]; // Define your desired order
          const indexA = desiredOrder.indexOf(a);
          const indexB = desiredOrder.indexOf(b);
      
          // If not found in the desired order, keep the original order
          if (indexA === -1 && indexB === -1) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
      
          return indexA - indexB;
        }),
        "Overall",
      ];
// alert("columnHeaders--->"+columnHeaders)
      setColumn(

        columnHeaders.map((header, idx) => {
          if(header == "Urban/Rural" || header == "School Management(Broad)" || header == "School Management(Detailed)" || header == "School Category(Broad)" || header == "School Category(Detailed)"
            || header == "Location"
          ){
            return {
              headerName: header,
              field: header?.replace(/\./g, ""),
              cellClass: idx > 1 ? "rightAligned" : "",
              filter :true,
              hide:
              (header === "School Management(Broad)" &&
                customColumnName === "School Management(Detailed)") ||
              (header === "School Management(Detailed)" &&
                customColumnName === "School Management(Broad)") ||
              (header === "Location" && !filter_query_by_location),
            };
          }

          else if (idx !== 0) {
            return {
              headerName: header,
              field: header?.replace(/\./g, ""),
              cellClass: idx > 1 ? "rightAligned" : "",
              hide:
                (header === "School Management(Broad)" &&
                  customColumnName === "School Management(Detailed)") ||
                (header === "School Management(Detailed)" &&
                  customColumnName === "School Management(Broad)") ||
                (header === "Location" && !filter_query_by_location),
            };
          } else {
            return {
              hide: true,
              headerName: header,
              field: header?.replace(/\./g, ""),
            };
          }
        })
      );
      }
       else if(!isNEP){
        cloneFilterDatas?.forEach((row) => {
        let location = row.regionName;
        let schManagementBroad = row.schManagementBroad;
        let schManagementDesc = row.schManagementDesc;
        // let foundationalAndPreparatory = row.foundationalAndPreparatory;
        // let middle = row.middle;
        // let secondary = row.secondary;
        let key;

        if (groupKeys.schManagementBroad) {
          key = row.schManagementBroad;
          customColumnName = "School Management(Broad)";
          setCustomColumns("School Management(Broad)");
          uniqueKeys.add("Pre Primary");
          uniqueKeys.add("Primary");
          uniqueKeys.add("Upper Primary");
          uniqueKeys.add("Secondary");
          uniqueKeys.add("Higher Secondary");
          
        } else if (groupKeys.schManagementDesc) {
          key = row.schManagementDesc;
          customColumnName = "School Management(Detailed)";
          setCustomColumns("School Management(Detailed)");
          uniqueKeys.add("Pre Primary");
          uniqueKeys.add("Primary");
          uniqueKeys.add("Upper Primary");
          uniqueKeys.add("Secondary");
          uniqueKeys.add("Higher Secondary");
        }

        /* row wise data for category */
        ////console.log('groupKeys', groupKeys)
        if (groupKeys.schCategoryBroad) {
          key = row.schCategoryBroad;
        } else if (groupKeys.schCategoryDesc) {
          uniqueKeys.delete("Higher Secondary");
          uniqueKeys.delete("Upper Primary");
          uniqueKeys.delete("Primary");
          uniqueKeys.delete("Pre Primary");
          uniqueKeys.delete("Secondary");
          // uniqueKeys.add("Foundational and Preparatory");
          uniqueKeys.add("Primary (1-5)");
          uniqueKeys.add("Middle (1-8)");
          uniqueKeys.add("Higher Secondary (1-12)");
          uniqueKeys.add("Middle (6-8)");
          uniqueKeys.add("Higher Secondary (6-12)");
          uniqueKeys.add("Secondary (1-10)");
          uniqueKeys.add("Secondary (6-10)");
          uniqueKeys.add("Secondary (9-10)");
          uniqueKeys.add("Higher Secondary (9-12)");
          uniqueKeys.add("Higher Secondary (11-12)");
          key = row.schCategoryDesc;
        }
        /* end here */

        ////console.log('key', key)
        key = key?.replace(/\./g, "");
        if (!uniqueKeys.has(key) && !uniqueKeys.has("")) {
          //   uniqueKeys.add(key);
        }

        const existingDataIndex = arr.findIndex(
          (data) =>
            data["Location"] === location &&
            data["School Management(Broad)"] === schManagementBroad &&
            data["School Management(Detailed)"] === schManagementDesc
        );
        if (existingDataIndex !== -1) {
          arr[existingDataIndex][key] =
            (arr[existingDataIndex][key] || 0) + parseInt(row.totSch, 10);
        } else {
            let newData = {
            Location: location,
            "School Management(Broad)": schManagementBroad,
            "School Management(Detailed)": schManagementDesc,
            "Pre Primary": parseInt(row.totSchCat12),
            "Primary": parseInt(row.totSchCat1), 
            "Upper Primary": parseInt(row.totSchCat2) + parseInt(row.totSchCat4),
            "Secondary": parseInt(row.totSchCat8) + parseInt(row.totSchCat6) + parseInt(row.totSchCat7),
            "Higher Secondary": parseInt(row.totSchCat11) + parseInt(row.totSchCat5) +  parseInt(row.totSchCat3) + parseInt(row.totSchCat10),
            "Primary (1-5)": parseInt(row.totSchCat1),
            "Middle (1-8)": parseInt(row.totSchCat2),
            "Higher Secondary (1-12)": parseInt(row.totSchCat3),
            "Middle (6-8)": parseInt(row.totSchCat4),
            "Higher Secondary (6-12)": parseInt(row.totSchCat5),
            "Secondary (1-10)": parseInt(row.totSchCat6),
            "Secondary (6-10)": parseInt(row.totSchCat7),
            "Secondary (9-10)": parseInt(row.totSchCat8),
            "Higher Secondary (9-12)": parseInt(row.totSchCat10),
            "Higher Secondary (11-12)": parseInt(row.totSchCat11),
            "Overall": parseInt(row.totSch, 10),
          };
          // if(groupKeys.schManagementDesc && groupKeys.schCategoryBroad){
          //   console.log(groupKeys)
          //   newData["Overall"] = parseInt(row.totSchCat12, 10) + parseInt(row.totSchCat1, 10) + parseInt(row.totSchCat2, 10) + parseInt(row.totSchCat8, 10) + parseInt(row.totSchCat11, 10);
          // }
     
          newData[key] = parseInt(row.totSch, 10);
          arr.push(newData);
        }
      });

      const columnHeaders = [
        "Serial Number",
        "Location",
        "School Management(Broad)",
        "School Management(Detailed)",
        ...Array.from(uniqueKeys).sort((a, b) => {
          const desiredOrder = [
            "Pre Primary",
            "Primary",
            "Upper Primary",
            "Secondary",
            "Higher Secondary",
            "Primary (1-5)",
            "Middle (1-8)",
            "Middle (6-8)",
            "Secondary (1-10)",
            "Secondary (6-10)",
            "Secondary (9-10)",
            "Secondary (1-12)",
            "Secondary (6-12)",
            "Secondary (9-12)",
            "Secondary (11-12)",
          ]; // Define your desired order
          const indexA = desiredOrder.indexOf(a);
          const indexB = desiredOrder.indexOf(b);

          // If not found in the desired order, keep the original order
          if (indexA === -1 && indexB === -1) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;

          return indexA - indexB;
        }),
        "Overall",
      ];
      setColumn(
        columnHeaders.map((header, idx) => {
          if (
            header == "Urban/Rural" ||
            header == "School Management(Broad)" ||
            header == "School Management(Detailed)" ||
            header == "School Category(Broad)" ||
            header == "School Category(Detailed)"
          ) {
            return {
              headerName: header,
              field: header?.replace(/\./g, ""),
              cellClass: idx > 1 ? "rightAligned" : "",
              filter: true,
              hide:
                (header === "School Management(Broad)" &&
                  customColumnName === "School Management(Detailed)") ||
                (header === "School Management(Detailed)" &&
                  customColumnName === "School Management(Broad)") ||
                (header === "Location" && !filter_query_by_location),
            };
          } else if (idx !== 0) {
            return {
              headerName: header,
              field: header?.replace(/\./g, ""),
              cellClass: idx > 1 ? "rightAligned" : "",
              hide:
                (header === "School Management(Broad)" &&
                  customColumnName === "School Management(Detailed)") ||
                (header === "School Management(Detailed)" &&
                  customColumnName === "School Management(Broad)") ||
                (header === "Location" && !filter_query_by_location),
            };
          } else {
            return {
              hide: true,
              headerName: header,
              field: header?.replace(/\./g, ""),
            };
          }
        })
      );
      }
    

      const newArr = arr.map((item, idx) => ({
        ...item,
        Total: countTotalPinnedWithRight(item),
        "Serial Number": idx + 1,
      }));
      setArrGroupedData(newArr);
      setGraphData(newArr);
    } else {
      setArrGroupedData(cloneFilterDatas);
      setGraphData(cloneFilterDatas);
      setColumn([
        {
          headerName: "Serial Number",
          field: "Serial Number",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressFiltersToolPanel: true,
        },
        {
          headerName: "Location",
          field: "regionName",
          hide: !filter_query_by_location,
        },
        {
          headerName: "School Management(Broad)",
          field: "schManagementBroad",
          suppressColumnsToolPanel: true,
          hide: false,
        },
        {
          headerName: "School Management(Detailed)",
          field: "schManagementDesc",
          suppressColumnsToolPanel: true,
          hide: false,
        },
        {
          headerName: "School Category(Broad)",
          field: "schCategoryBroad",
          suppressColumnsToolPanel: true,
          hide: false,
        },
        {
          headerName: t(""),
          field: "schCategoryDesc",
          suppressColumnsToolPanel: true,
          hide: false,
        },
        {
          headerName: "Total No. of Schools",
          field: "totSch",
          cellClass: 'ag-right-aligned-cell'
        },
      ]);
    }
    //  if (!flag) {
    //   setShowTransposeds(!showTransposed);
    // }
  };
  useEffect(() => {
    if (!showTransposed) {
      const appendedObj = {};
      const removefirstTwoColumns = columns.slice(2);
      removefirstTwoColumns.forEach((item) => {
        if (item.field === customColumnNames) {
          appendedObj[item.field] = "Total";
        } else if (item.field === customColumnNames) {
          appendedObj[item.field] = "Total";
        } else {
          appendedObj[item.field] = calculateTotal(item.field);
        }
      });
      setPinnedBottomRowDataByRow([appendedObj]);
    }
  }, [columns]);

  const getLastTrueToShowTotal = () => {
    const lastTrueKey = Object.keys(groupKeys).reduce((lastKey, key) => {
      if (groupKeys[key]) {
        return key;
      }
      return lastKey;
    }, null);
    return lastTrueKey;
  };
  function calculateTotal(fieldName) {
    if (!arrGroupedData) return 0;
    return arrGroupedData.reduce(
      (total, row) => total + parseFloat(row[fieldName] || 0),
      0
    );
  }

  const pinedBottomRowDatas = [
    {
      ...(getLastTrueToShowTotal()
        ? { [getLastTrueToShowTotal()]: "Total" }
        : { regionName: "Total" }),
      totSch: calculateTotal("totSch"),
    },
  ];

  /*------------Export data to Excel and PDF-------------*/
  const getHeaderToExport = (gridApi) => {
    const columns = gridApi.api.getAllDisplayedColumns();
    const headerCellSerialNumber = {
      text: "Serial Number",
      headerName: "S.NO.",
      bold: true,
      margin: [0, 12, 0, 0],
    };
    const headerRow = columns.map((column) => {
      const { field, headerName } = column.getColDef();
      const sort = column.getSort();
      const headerNameUppercase = field[0].toUpperCase() + field.slice(1);
      const headerCell = {
        text: headerNameUppercase + (sort ? ` (${sort})` : ""),
        headerName: headerName,
        bold: true,
        margin: [0, 12, 0, 0],
      };
      return headerCell;
    });
    headerRow.unshift(headerCellSerialNumber);
    return headerRow;
  };
  const getRowsToExport = (gridApi) => {
    const columns = gridApi.api.getAllDisplayedColumns();
    const getCellToExport = (column, node) => ({
      text: gridApi.api.getValue(column, node) ?? "",
    });
    const rowsToExport = [];
    gridApi.api.forEachNodeAfterFilterAndSort((node) => {
      const rowToExport = [];
      rowToExport.push({ text: rowsToExport.length + 1 });
      columns.forEach((column) => {
        rowToExport.push(getCellToExport(column, node));
      });
      rowsToExport.push(rowToExport);
    });
    return rowsToExport;
  };
  const getDocument = (gridApi) => {
    const headerRow = getHeaderToExport(gridApi);
    const rows = getRowsToExport(gridApi);
    const date = new Date();
    const formattedDate = `${date.toLocaleDateString("en-GB", {
      weekday: "long", // Full day name (e.g., Friday)
    })}, ${date.toLocaleDateString("en-GB", {
      day: "2-digit", // Day of the month (e.g., 13)
      month: "long", // Full month name (e.g., September)
      year: "numeric", // Full year (e.g., 2024)
    })}, ${date.toLocaleTimeString("en-US", {
      hour: "2-digit", // Hour (e.g., 10)
      minute: "2-digit", // Minutes (e.g., 25)
      hour12: true, // 12-hour format with AM/PM
    })}`;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "in",
      format: [12, 20],
    });
    // Function to add header
    const addHeader = () => {
      doc.setFontSize(22);
      doc.setTextColor("black");
      doc.setFont("Helvetica", "bold");
      // doc.text("UDISE+", 0.6, 1);

      // Add the header text
      doc.text(
        "Unified District Information System for Education",
        doc.internal.pageSize.width / 2,
        0.7,
        {
          fontStyle: "bold",

          color: "black",
          align: "center",
        }
      );
      doc.setFont("Helvetica", "normal");

      doc.setFontSize(18);

      doc.text(
        "Department of School Education & Literacy, Ministry of Education, Government of India",
        doc.internal.pageSize.width / 2,
        1.1,
        {
          // fontStyle: '',
          color: "black",
          align: "center",
        }
      );

      doc.setFont("Helvetica", "bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      doc.text(`${report.report_name}`, doc.internal.pageSize.width / 2, 1.5, {
        fontSize: 12,
        fontStyle: "bold",

        color: "black",
        align: "center",
      });

      doc.setFont("Helvetica", "bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      // doc.text(`${stateName}`, doc.internal.pageSize.width / 2, 1.7, {
      //   fontSize: 12,
      //   color: "black",
      //   align: "center",
      // });

      doc.setFont("bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      doc.text(
        `Academic Year : ${local_year}`,
        doc.internal.pageSize.width / 2,
        1.9,
        {
          fontSize: 12,
          color: "black",
          align: "center",
        }
      );

      const textContent = generateTextContent(
        stateName,
        nationalWiseName,
        stateWiseName,
        local_district,
        district,
        districtWiseName,
        local_block,
        block,
        blockWiseName
      );
      if (textContent) {
        doc.text(textContent, doc.internal.pageSize.width / 2, 2.3, {
          fontSize: 12,
          color: "black",
          align: "center",
        });
      }

      // Set the margin for the image from the left
      const leftMargin = 0.1; // Margin from the left (in inches)
      const topLeftX = leftMargin; // X position from the left including margin
      const topLeftY = 0; // Y position from the top (in inches)
      const imgWidth = 2; // Image width (in inches)
      const imgHeight = 2; // Image height (in inches)

      doc.setFontSize(20);
      doc.setTextColor("blue");

      // Add the satyameva image with the specified left margin
      doc.addImage(
        satyamevaimg,
        "PNG",
        topLeftX,
        topLeftY,
        imgWidth,
        imgHeight
      );

      doc.setTextColor("blue");
      doc.setFont("bold");

      // Get page dimensions
      const pageWidthE = doc.internal.pageSize.getWidth();
      const pageHeightE = doc.internal.pageSize.getHeight();

      const imgWidthE = 2.8; // Image width (in inches)
      const imgHeightE = 1.4; // Image height (in inches)
      const marginRight = 0.7; // Right margin (in inches)

      // Calculate x position for top-right corner
      const topRightX = pageWidthE - imgWidthE - marginRight;
      const topRightY = 0.3; // Y position from the top (in inches)

      // Add the education image at the top-right corner
      doc.addImage(
        udise,
        "JPG",
        topRightX, // X position for top-right
        topRightY, // Y position for top-right
        imgWidthE,
        imgHeightE
      );

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Example: Draw a rectangle around the whole page
      // doc.setLineWidth(0.02); // Thicker border for the page
      // doc.rect(0.1, 0.1, pageWidth - 0.2, pageHeight - 0.2); // x, y, width, height
    };
    // Function to add footer
    const addFooter = () => {};
    const table = [];
    table.push(headerRow.map((cell) => cell.headerName));
    rows.forEach((row) => {
      table.push(row.map((cell) => cell.text));
    });
    addHeader();
    doc.autoTable({
      head: [table[0]],
      body: table.slice(1),
      theme: "grid",
      startY: 2.7,
      styles: {
        cellPadding: 0.15, // Adjust cell padding if needed
        lineColor: [0, 0, 0], // Set border color (black in this case)
        lineWidth: 0.001, // Set border width
        fillColor: [255, 255, 255], // Default background color (white)
        textColor: [0, 0, 0],
      },
      headStyles: {
        fontSize: 14, // Set the font size for the header row
        fontStyle: "bold", // Make the header text bold (optional)
        textColor: [0, 0, 0],
        cellPadding: 0.2, // Set text color for the header row
      },

      didParseCell: function (data) {
        const headerRow = getHeaderToExport(gridApi); // Get the header row

        // Get the header text for this column
        const columnHeaderText = headerRow[data.column.index]?.text;
        if (columnHeaderText === "Serial Number") {
          data.cell.styles.halign = "center"; // Center-align the content for "Serial Number"
        } else if (columnHeaderText === "RegionName") {
          data.cell.styles.halign = "left"; // Center-align the content for "Serial Number"
        } else if (columnHeaderText === "Location") {
          data.cell.styles.halign = "left"; // Center-align the content for "Serial Number"
        } else if (
          columnHeaderText === "School Management(Broad)" ||
          columnHeaderText === "School Management(Detailed)"
        ) {
          data.cell.styles.halign = "left"; // Center-align the content for "Serial Number"
        } else {
          data.cell.styles.halign = "right";
        }
      },

      afterPageContent: addFooter,
    });

    const totalPages = doc.internal.getNumberOfPages();

    doc.page = 1;
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(14);
      doc.setFont("helvetica", "normal");
      doc.addImage(
        nic,
        "JPG",
        0.6, // X position for top-right
        11.5, // Y position for top-right
        1,
        0.3
      );
      doc.setTextColor("black");
      doc.text(
        `Page ${i} of ${totalPages}`,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 0.2,
        { align: "center", color: "black" }
      );

      doc.text(
        `Report generated on : ${formattedDate}`,
        doc.internal.pageSize.width - 1,
        doc.internal.pageSize.height - 0.2,
        { fontSize: 12, align: "right", color: "black" }
      );
    }

    for (let i = 0; i < totalPages; i++) {
      doc.setPage(i + 1);
      doc.autoTable({
        startY: 3.5,
      });
    }
    return doc;
  };
  const exportToPDF = () => {
    const doc = getDocument(gridApi);
    doc.save(`${report.report_name}.pdf`);
  };
    const { exportToExcel } = useExportToExcel(gridApi, report, local_year, stateName, nationalWiseName, stateWiseName, local_district, district, districtWiseName, local_block, block, blockWiseName, generateTextContent);

  const handleExportData = (e) => {
    const { value } = e.target;
    if (value === "export_pdf") {
      exportToPDF();
    }
    if (value === "export_excel") {
      exportToExcel();
    }
    document.getElementById("export_data").selectedIndex = 0;
  };

  useEffect(() => {
    handleButtonClick("School Management", "broad", true);
    handleButtonClick("School Category", "broad", true);
  }, []);

  useEffect(() => {
    if (intialTeacherData && intialTeacherData.length > 0) {
      handleCustomKeyInAPIResponse();
    }
  }, [intialTeacherData]);

  useEffect(() => {
    if (cloneFilterDatas.length > 0) {
      setShowTransposeds((prevShowTransposed) => {
        if (!prevShowTransposed) {
          switchColumnsToRow(true);
        }
        return true;
      });
    }
  }, [cloneFilterDatas, location.pathname]);

  // chart related code

  const years = [
    "2018-2019",
    "2019-2020",
    "2020-2021",
    "2021-2022",
    "2022-2023",
  ];

  // get last five years data for School Management

////console.log("school_data_Year--->"+JSON.stringify(school_data_Year))

  const govtSchool = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolGovt)
  );

  // alert("govtSchool--->"+govtSchool);
  ////console.log('govtSchool', govtSchool)
  const govtAided = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolGovtAided)
  );
  const pvtSchool = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolPvt)
  );
  const otherSchool = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolOther)
  );

  // get last five years data for School Category

  const upperPrimData = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolUPry)
  );
  const secondaryData = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolSec)
  );
  const higherSecData = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolHSec)
  );
  const primaryData = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolPry)
  );

  // handle by table and graph data when tab change
  useEffect(() => {
    if (headerData.activeTab === "table") {
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", selectedDYear);
      dispatch(fetchArchiveServicesProfileSchoolData(initialPayload));
    }
    if (headerData.activeTab === "graph") {
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", selectedDYear);
      initialPayload.valueType = 2;
      dispatch(allFilter(initialPayload));
      dispatch(fetchSchoolProfileStatsData(initialPayload));
      initialPayload.valueType = 1;
      dispatch(allFilter(initialPayload));
      dispatch(fetchSchoolProfileDataYear(initialPayload));
    }
  }, [headerData.activeTab, i18n.language]);

  const handleScrollComplete = () => {
    setIsScrollComplete(true);
  };
  // Use `arrGroupedData` as the source data and apply the `handleMissingData` function to replace null values with "0".
  // The `handleMissingData` function is used to process data and ensure missing values are replaced,
  // which is then displayed in AG Grid using the processed data.


  
  //console.log("arrGroupedData---->",arrGroupedData);
  
 const result=  useReportOverallLocationSum(arrGroupedData)

 ////console.log('result', result)
const arrGroupedDataTable = handleMissingData(isCheckFilter?arrGroupedData:
     filter_query_by_location ? result : arrGroupedData,
     columns
   );

  //console.log('arrGroupedDataTable', arrGroupedDataTable)

  const onFilterChanged = () => {
    const gridApi = gridApiRef.current;
        const appendedObj = {};
        const removefirstTwoColumns = columns.slice(2);
        const allData = [];
        gridApi.forEachNodeAfterFilter((node) => {
          if(node.data['School Management(Broad)'] !="Overall"){
        allData.push(node.data);
          }
      });
        removefirstTwoColumns.forEach((item) => {
         if(item.field==="School Management(Broad)" || item.field==="School Management(Detailed)"){
            appendedObj[item.field] ="Total";
        }else {
            appendedObj[item.field] = filterCalculateTotal(allData,item.field);
          }
        });
    
        if(filter_query_by_location){
          const columnDefs = gridApi.getColumnDefs();
          setIsCheckFilter(false);
          for (let i = 0; i < columnDefs.length; i++) {
            const columnId = columnDefs[i].field;
            const filterInstancePro = gridApi.getColumnFilterInstance(columnId);
            const getValueFromFilterInstance = async () => {
              try {
                const filterInstance = await filterInstancePro;
    if(filterInstance && filterInstance?.appliedModel !=null){
                if(filterInstance?.appliedModel?.values?.length != filterInstance?.valueModel?.allValues?.size){
                  setIsCheckFilter(true);
                }
              }
              } catch (error) {
                console.error("Error fetching filter model:", error);
              }
            };
            getValueFromFilterInstance();
          }
        }

        setPinnedBottomRowDataByRow([appendedObj]);
      };
    
    
      function filterCalculateTotal(data,fieldName) {
        if (!data) return 0;
        return data.reduce(
          (total, row) => total + parseFloat(row[fieldName] || 0),
          0
        );
      }
      
      console.log('graphData',graphData)
  ////console.log('columns', columns)
  return (
    <>
      <ScrollToTopOnMount onScrollComplete={handleScrollComplete} />
      <section className="infrastructure-main-card p-0" id="content">
        <div className="bg-grey2 pb-0 pt-0 header-bar tab-for-graph">
          <div className="blue-strip">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-10 col-lg-10">
                  <div className="common-content text-start map-heading-map">
                    {report && (
                      <div className="common-content text-start map-heading-map d-flex align-items-center">
                        <span className="me-3">
                          {t("reports_id")} {report.id}
                        </span>
                        <h2 className="heading-sm1 mb-0 mt-0">
                          {report.report_name}
                        </h2>
                      </div>
                    )}
                  </div>
                </div>
                {activeTab !== "about" && activeTab !== "graph" && (
                  <div className="col-md-2 col-lg-2">
                    <div className="select-infra button-group-filter">
                      <div className="indicator-select">
                        <select
                          id="export_data"
                          className="form-select bg-grey2"
                          onChange={handleExportData}
                          defaultValue={""}
                        >
                          <option className="option-hide">
                            {t("download_report")}
                          </option>
                          <option value="export_pdf">
                            {" "}
                            {t("download_as_pdf")}{" "}
                          </option>
                          <option value="export_excel">
                            {t("download_as_excel")}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="container pb-4">
            <div className="row">
              {activeTab !== "about" && activeTab !== "graph" && (
                <div className="col-md-12 col-lg-12 d-flex align-items-center">
                  <div className="tab-text-infra me-4">{t("view_data_by")}</div>
                  <ul className="nav nav-tabs mul-tab-main">
                    <li className={`nav-item ${multiMgt}`}>
                      <button
                        type="button"
                        className={`nav-link dark-active ${mgt}`}
                        onClick={(e) =>
                          handleButtonClick("School Management", "broad", e)
                        }
                      >
                        {t("school_management_board")}
                      </button>
                      <button
                        type="button"
                        className={`nav-link dark-active details-multi ${mgt_Details}`}
                        id="school_mgt_details"
                        onClick={(e) =>
                          handleButtonClick("School Management", "desc", e)
                        }
                      >
                        {t("detailed_view")}
                      </button>
                    </li>
                    <li className={`nav-item ${multiCat}`}>
                      <button
                        type="button"
                        className={`nav-link dark-active1 ${cat}`}
                        onClick={(e) =>
                          handleButtonClick("School Category", "broad", e)
                        }
                      >
                        {t("school_category_board")}
                      </button>
                      <button
                        type="button"
                        className={`nav-link dark-active1 details-multi ${cat_Details}`}
                        onClick={(e) =>
                          handleButtonClick("School Category", "desc", e)
                        }
                      >
                        {t("detailed_view")}
                      </button>
                      {/* <button
                      type="button"
                      className={`nav-link dark-active details-multi`}
                      id="cat_row_column"
                      onClick={(e) => switchColumnsToRow()}

                    >
                      By {showTransposed ? "Column" : "Rows"}
                    </button> */}
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="bg-grey ptb-30">
          <div className="container tab-for-graph position-relative">
            <div className="row align-items-center report-inner-tab">
              <ul className="nav nav-tabs mul-tab-main nep-position">
                <li className={`nav-item ${multiCat} national`}>
                  <button
                    type="button"
                    className={`nav-link dark-active1 ${
                      !isNEP ? "active" : ""
                    }`}
                    onClick={() => setIsNEP(false)}
                  >
                    Pre NEP
                  </button>
                  <button
                    type="button"
                    className={`nav-link details-multi dark-active1 ${
                      isNEP ? "active" : ""
                    }`}
                    onClick={() => setIsNEP(true)}
                  >
                    NEP
                  </button>
                </li>
              </ul>
              <div className="col-md-12 col-lg-12 table-text-i table-brud-card">
                {activeTab !== "about" && (
                  <h4 className="brudcrumb_heading">
                    {t("showing_result_for")} <span>&nbsp;{local_state}</span>
                    <span className="material-icons-round">chevron_right</span>
                    {local_district !== "District" && (
                      <>
                        <span>{local_district}</span>
                        <span className="material-icons-round">
                          chevron_right
                        </span>
                      </>
                    )}
                    {local_block !== "Block" && (
                      <>
                        <span>{local_block}</span>
                        <span className="material-icons-round">
                          chevron_right
                        </span>
                      </>
                    )}
                    <span>{local_year}</span>
                  </h4>
                )}

                <Tabs
                  defaultActiveKey={type}
                  id="uncontrolled-tab-example"
                  className="nav-absolute"
                  onSelect={(k) => setActiveTab(k)}
                >
                  {/* <Tab eventKey="about" title={t("about")}>
                    <div className="about-card mt-4">
                      <h2 className="heading-sm2 mb-2">{t("about_us")}</h2>
                      <p> The "Number of Schools Approachable by All-Weather Roads by Management and School Category" refers to an analysis of educational institutions that are accessible through roads that remain functional throughout the year, regardless of weather conditions. This metric is critical in understanding the infrastructure challenges faced by schools, especially in remote or rural areas.

The data is categorized by school management types, such as government, private, and aided schools, as well as by school categories, including primary, upper primary, secondary, and higher secondary levels. This classification provides a clear picture of the accessibility of schools based on their management and educational offerings.

Access to all-weather roads ensures that students, teachers, and resources can reach schools without disruption, even during adverse weather conditions like heavy rains or snow. It significantly impacts attendance, timely delivery of educational materials, and the overall functioning of schools. Schools that are not accessible year-round face challenges in ensuring consistent learning experiences and maintaining regular academic schedules.

By analyzing this data, policymakers can identify schools that require improved connectivity and prioritize infrastructure development in those areas. Ensuring that all schools are approachable by all-weather roads is essential for equitable access to education, particularly for students in underserved and geographically challenging regions. This initiative contributes to reducing dropouts and bridging the urban-rural education gap, fostering a more inclusive and resilient educational system.
</p>
                    </div>
                  </Tab> */}
                  <Tab eventKey="table" title={t("table")}>
                    {school_datas.isLoading && <GlobalLoading />}
                    <div className="multi-header-table">
                      <div
                        className=" multi-header-table ag-theme-material ag-theme-custom-height ag-theme-quartz h-300"
                        style={{ height: 450 }}
                      >
                        <AgGridReact
                          key={gridRefreshKey}
                          rowData={
                            arrGroupedDataTable ? arrGroupedDataTable : []
                          }
                          getRowStyle={(params) => {
                            if (params.data.isTotalRow) {
                              return { fontWeight: 'bold' };  // Apply inline bold style for totals row
                            }
                            return {};  // Default style for other rows
                          }}
                          columnDefs={columns}
                          defaultColDef={defColumnDefs}
                          onColumnVisible={onColumnVisible}
                          onGridReady={onGridReady}
                          groupDisplayType="custom"
                          groupHideOpenParents={true}
                          onFilterChanged={onFilterChanged}
                          pinnedBottomRowData={pinnedBottomRowDataByRows}
                          excelStyles={excelStyles}
                        />
                      </div>
                    </div>
                  </Tab>

                  <Tab disabled eventKey="graph" title={t("chart")} >
                    {school_data_valueTypes.isLoading && <GlobalLoading />}
                    {school_data_Years.isLoading && <GlobalLoading />}
                    <div className="card-box-impact tab-for-graph report-1003 mt-4">
                         <div className="row">
                                              <div className="col-md-6 col-lg-6 impact-box-content-education">
                                                                        <div className="text-btn-d">
                                                                          <h2 className="heading-sm">
                                                                          Total No. of Schools Approachable by All-Weather Roads by School Management
                                                                          </h2>
                                                                        </div>
                                                                        <div className="col-md-12 col-lg-12 d-flex align-items-center">
                                                                          <div className="tab-text-infra me-4">
                                                                            {" "}
                                                                            {t("view_data_by")}
                                                                          </div>
                                                                          <ul className="nav nav-tabs mul-tab-main">
                                                                            <li className={`nav-item ${multiMgt}`}>
                                                                              <button
                                                                                type="button"
                                                                                className={`nav-link dark-active ${mgt}`}
                                                                                onClick={(e) =>
                                                                                  handleButtonClick(
                                                                                    "School Management",
                                                                                    "broad",
                                                                                    e
                                                                                  )
                                                                                }
                                                                              >
                                                                                {t("school_management_board")}
                                                                              </button>
                                                                              <button
                                                                                type="button"
                                                                                className={`nav-link dark-active details-multi ${mgt_Details}`}
                                                                                id="school_mgt_details"
                                                                                onClick={(e) =>
                                                                                  handleButtonClick(
                                                                                    "School Management",
                                                                                    "desc",
                                                                                    e
                                                                                  )
                                                                                }
                                                                              >
                                                                                {t("detailed_view")}
                                                                              </button>
                                                                            </li>
                                                                          </ul>
                                                                        </div>
                                              
                                                                        <SchoolGraph1006
                                                                          graphData={graphData}
                                                                          groupKeys={groupKeys}
                                                                           isNEP={isNEP}
                                                                        />
                                                                      </div>
                                              
                                                                      <div className="col-md-6 col-lg-6">
                                                                        <div className="text-btn-d">
                                                                          <h2 className="heading-sm">
                                                                          Total No. of Schools Approachable by All-Weather Roads by School Category
                                                                          </h2>
                                                                        </div>
                                                                        <div className="col-md-12 col-lg-12 d-flex align-items-center">
                                                                          <div className="tab-text-infra me-4">
                                                                            {" "}
                                                                            {t("view_data_by")}
                                                                          </div>
                                                                          <ul className="nav nav-tabs mul-tab-main">
                                                                            <li className={`nav-item ${multiMgt}`}>
                                                                              <button
                                                                                type="button"
                                                                                className={`nav-link dark-active ${cat}`}
                                                                                onClick={(e) =>
                                                                                  handleButtonClick(
                                                                                    "School Category",
                                                                                    "broad",
                                                                                    e
                                                                                  )
                                                                                }
                                                                              >
                                                                                {t("school_category_board")}
                                                                              </button>
                                                                              <button
                                                                                type="button"
                                                                                className={`nav-link dark-active details-multi ${cat_Details}`}
                                                                                id="school_mgt_details"
                                                                                onClick={(e) =>
                                                                                  handleButtonClick(
                                                                                    "School Category",
                                                                                    "desc",
                                                                                    e
                                                                                  )
                                                                                }
                                                                              >
                                                                                {t("detailed_view")}
                                                                              </button>
                                                                            </li>
                                                                          </ul>
                                                                        </div>
                                              
                                                                        <SchoolGraphCat1006
                                                                          graphData={graphData}
                                                                          groupKeys={groupKeys}
                                                                           isNEP={isNEP}
                                                                        />
                                                                      </div>
                                              
                                                                      <div className="col-md-6 col-lg-6">
                                                                        <div className="impact-box-content-education mt-3">
                                                                          <div className="text-btn-d">
                                                                            <h2 className="heading-sm">
                                                                            Percentage of Schools Approachable by All-Weather Roads by School Management (Broad)
                                                                            </h2>
                                                                          </div>
                                              
                                                                          <SchoolGraph2Manage1006
                                                                            graphData={graphData}
                                                                            groupKeys={groupKeys}
                                                                          />
                                                                        </div>
                                                                      </div>
                                                                      <div className="col-md-6 col-lg-6">
                                                                        <div className="impact-box-content-education mt-3">
                                                                          <div className="text-btn-d">
                                                                            <h2 className="heading-sm">
                                                                            Percentage of Schools Approachable by All-Weather Roads by School Category (Broad)
                                                                            </h2>
                                                                          </div>
                                              
                                                                          <SchoolGraph2Cat1006
                                                                            graphData={graphData}
                                                                            groupKeys={groupKeys}
                                                                             isNEP={isNEP}
                                                                          />
                                                                        </div>
                                                                      </div>
                                            </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FilterDropdownCommom358 />
      <Footer />
    </>
  );
}
